import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "Screens/components/MainLayout";
import MainPara from "Screens/components/MainPara";
import HomeSocial from "Screens/components/HomeSocial";
import { set_HomeData, set_SocialData } from "../../Redux/slices/dataSlice";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { get_home, get_social } from "http/components/Requests";
import { HandleLoading } from "Utils/Helpers/ApiServices";

export default function HomeIndex() {
  const dispatch = useDispatch();
  const { home } = useSelector((state) => ({
    home: state.data.home,
  }));

  useEffect(() => {
    getHomeData();
  }, []);

  const getHomeData = async () => {
    dispatch(HandleLoading(true));
    const home_response = await get_home();
    if (CheckApiStatus(home_response))
      dispatch(set_HomeData(home_response.data));
    const social_response = await get_social();
    if (CheckApiStatus(social_response))
      dispatch(set_SocialData(social_response.data));
    dispatch(HandleLoading(false));
  };

  return (
    <MainLayout
      centered
      pageContent={
        <>
          {home &&
            home.infos.map((items, index) => {
              return (
                <MainPara
                  key={`home-data-${index + 1}`}
                  title={items.title}
                  text={items.body}
                />
              );
            })}
          <HomeSocial />
        </>
      }
      imageSrc={home && home.image}
      imageAlt={"HomePageImage"}
    />
  );
}
